import { tracLinkInitialState } from './initial-state';
import { TracLinkActions } from './action-creators';
import { TracLinkState } from './state';
import * as actions from './actions';
import { TourEvent } from '@common/types/traclink/tour-event';
import _ from 'lodash';

const tracLinkReducer = (
  state: TracLinkState = tracLinkInitialState,
  action: TracLinkActions
): TracLinkState => {
  switch (action.type) {
    case actions.RESET_EVENT_DRAFTS: {
      return { ...state, tourEventDrafts: { edit: {}, new: [] } };
    }

    case actions.CREATE_EVENT_DRAFT: {
      const { draftKey, event } = action;

      const editDrafts = { ...state.tourEventDrafts.edit };
      let newDrafts = [...state.tourEventDrafts.new];

      switch (draftKey) {
        case 'new':
          newDrafts = [event, ...newDrafts];
          break;
        case 'edit':
          const newDraftsIds = newDrafts.map((d) => d.id);
          if (newDraftsIds.includes(event.id)) {
            newDrafts = newDrafts.map((d) => (d.id === event.id ? event : d));
            break;
          }

          editDrafts[event.id] = event;
          break;
      }

      return {
        ...state,
        tourEventDrafts: { edit: editDrafts, new: newDrafts },
      };
    }

    case actions.GET_TOUR_EVENTS_SUCCESS: {
      return {
        ...state,
        tourEvents: _.uniqBy([...state.tourEvents, ...action.results], 'id'),
        ...(action.drafts ? { tourEventDrafts: action.drafts } : {}),
        tourEventsError: null,
      };
    }

    case actions.GET_TOUR_EVENTS_ERROR: {
      return {
        ...state,
        tourEventsError: action.code,
      };
    }
    case actions.ADD_TOUR_EVENT_SUCCESS: {
      return {
        ...state,
        tourEvents: [...state.tourEvents, action.results],
        tourEventsError: null,
      };
    }

    case actions.ADD_TOUR_EVENT_ERROR: {
      return {
        ...state,
        tourEventsError: action.code,
      };
    }
    case actions.UPDATE_TOUR_EVENT_SUCCESS: {
      const updatedTourEvent = action.results;
      const newTourEvents = state.tourEvents.reduce(
        (acc: TourEvent[], tourEvent) => {
          if (tourEvent.id === updatedTourEvent.id) {
            acc.push(updatedTourEvent);
          } else {
            acc.push(tourEvent);
          }
          return acc;
        },
        []
      );

      return {
        ...state,
        tourEvents: [...newTourEvents],
        tourEventsError: null,
      };
    }

    case actions.UPDATE_TOUR_EVENT_ERROR: {
      return {
        ...state,
        tourEventsError: action.code,
      };
    }
    case actions.DELETE_TOUR_EVENT_SUCCESS: {
      const newTourEvents = state.tourEvents.filter(
        (tour) => tour.id !== action.tourId
      );

      return {
        ...state,
        tourEvents: [...newTourEvents],
        tourEventsError: null,
      };
    }

    case actions.DELETE_TOUR_EVENT_ERROR: {
      return {
        ...state,
        tourEventsError: action.code,
      };
    }

    default:
      return state;
  }
};

export default tracLinkReducer;
